import http from '../http-common'
import { APIBaseFunctions, APIDataSliceObj, defaultAPILimit } from '@/components/Utility/APIBase'

export class Menus extends APIBaseFunctions {
  static MenusDataService = class {
    private static cachedMenusDataDataSliceObj: APIDataSliceObj = {
      slicemode: 0,
      start: 0,
      limit: defaultAPILimit,
      page: 0,
      pagesize: 0,
      totalcount: 0
    }

    static async getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      const currentDataSliceObj = Menus.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedMenusDataDataSliceObj }, dataSliceObj)
      const count = (await this.getCount()).data
      if (sortingOrder.length > 0) {
        // return http.get(`/menus?${sortingOrder}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
        return http.get(`/menus?${sortingOrder}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${count}` + '&populate=*')
      }
      return http.get(`/menus?pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${count}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
    }

    static get (id: string) {
      return http.get(`/menus/${id}?populate=*`)
    }

    static getCount (extraCountParameter = '') {
      return http.get('/menus/count' + (extraCountParameter.length > 0 ? `?&${extraCountParameter}` : ''))
    }

    static create (data: any) {
      return http.post('/menus', data)
    }

    static update (id: string, data: any) {
      return http.put(`/menus/${id}`, data)
    }

    static delete (id: string) {
      return http.delete(`/menus/${id}`)
    }

    static deleteAll () {
      return http.delete('/menus')
    }

    static findByMenuStatus (status: boolean, sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      let sortingOrderParameter = ''
      const currentDataSliceObj = Menus.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedMenusDataDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        sortingOrderParameter = `&_sort=${sortingOrder}`
      }

      return http.get(`/menus?filters[menu_status]=${status}${sortingOrderParameter}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
    }

    static findBySearchTerm (status: boolean, ignoreStatus: boolean, searchTerm: string, sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      let retVal
      let sortingOrderParameter = ''
      const currentDataSliceObj = Menus.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedMenusDataDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        sortingOrderParameter = `${sortingOrder}`
      }

      if (ignoreStatus) {
        retVal = http.get(`/menus?filters[$or][0][menu_titel][$contains]=${searchTerm}&filters[$or][1][menu_type_id][menu_type_titel][$contains]=${searchTerm}${sortingOrderParameter}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
      } else {
        retVal = http.get(`/menus?filters[$or][0][menu_titel][$contains]=${searchTerm}&filters[$or][1][menu_type_id][menu_type_titel][$contains]=${searchTerm}&filters[$or][2][menu_status]=${status}${sortingOrderParameter}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
      }

      return retVal
    }
  }

  static MenuTypesDataService = class {
    private static cachedMenuTypesDataSliceObj: APIDataSliceObj = {
      slicemode: 0,
      start: 0,
      limit: defaultAPILimit,
      page: 0,
      pagesize: 0,
      totalcount: 0
    }

    static getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
      const currentDataSliceObj = Menus.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedMenuTypesDataSliceObj }, dataSliceObj)

      if (sortingOrder.length > 0) {
        return http.get(`/menu-types?sort=${sortingOrder}&pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
      }

      return http.get(`/menu-types?pagination[page]=${currentDataSliceObj.page + 1}&pagination[pageSize]=100000` + (extraParameter.length > 0 ? `&${extraParameter}` : '') + '&populate=*')
    }

    static get (id: string) {
      return http.get(`/menu-types/${id}`)
    }

    static getCount () {
      return http.get('/menu-types/count')
    }

    static create (data: any) {
      return http.post('/menu-types', data)
    }

    static update (id: string, data: any) {
      return http.put(`/menu-types/${id}`, data)
    }

    static delete (id: string) {
      return http.delete(`/menu-types/${id}`)
    }

    static deleteAll () {
      return http.delete('/menu-types')
    }
  }
}

export default new Menus()
